import React from 'react';
// import Rule from './Rule';
import { CQAppConstant } from '../../../../../../app-constants';
import RuleComponent from './rule-component';

class GroupComponent extends React.Component<{
    groupIndex: string,
    groupData: any,
    lookupFields: any[],
    layoutFields: any[],
    addGroupedFilter: any,
    addCriteria: any,
    deleteCriteria: any,
    updateRuleData: any,
    updateLogicOperator: any,
    selectedReferenceFields:any[]
}, { data: any }> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: props.groupData,
        };
    }

    render() {
        return (
            <>
                <li key={this.props.groupIndex} className="slds-expression__group">
                    {/* {this.props.groupIndex} */}
                    <fieldset>
                        {/* <legend className="slds-expression__legend slds-expression__legend_group">
                                                            <span>AND</span>
                                                            <span className="slds-assistive-text">Condition Group 1</span>
                                                        </legend> */}
                        <div className="slds-expression__options">
                            <div className="slds-form-element">
                                <label className="slds-form-element__label">Take Action When</label>
                                <div className="slds-form-element__control">
                                    <div className="slds-select_container">
                                        <select className="slds-select"
                                            value={this.props.groupData.logic}
                                            onChange={e => this.props.updateLogicOperator(e, this.props.groupIndex)}>
                                            
                                            <option value="">Please select</option>
                                            {
                                                CQAppConstant.LOOKFILTER_CONDITION_OPERATORS
                                                    .map((operator: { label: string, value: string }, index: number) => {
                                                        return (<option key={index} value={operator.value}>
                                                            {`${operator.label} - ${operator.value}`}</option>);
                                                    })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ul>
                            {
                                this.props.groupData.filters.length > 0 &&
                                this.props.groupData.filters.map((groupFilter: any, groupFilterIndex: number) => {
                                    if ((groupFilter.hasOwnProperty('field'))) {
                                        return <RuleComponent key={groupFilterIndex} ruleIndex={`${this.props.groupIndex}/${groupFilterIndex.toString()}`} ruleData={groupFilter}
                                            lookupFields={this.props.lookupFields} layoutFields={this.props.layoutFields}
                                            deleteCriteria={this.props.deleteCriteria}
                                            updateRuleData={this.props.updateRuleData}
                                            selectedReferenceFields={this.props.selectedReferenceFields} />;
                                    }
                                    else {
                                        return <GroupComponent
                                            key={groupFilterIndex}
                                            groupIndex={`${this.props.groupIndex}/${groupFilterIndex.toString()}`}
                                            groupData={groupFilter} lookupFields={this.props.lookupFields} layoutFields={this.props.layoutFields}
                                            addGroupedFilter={this.props.addGroupedFilter}
                                            addCriteria={this.props.addCriteria}
                                            deleteCriteria={this.props.deleteCriteria}
                                            updateRuleData={this.props.updateRuleData}
                                            updateLogicOperator={this.props.updateLogicOperator}
                                            selectedReferenceFields={this.props.selectedReferenceFields}
                                        />;
                                    }
                                })
                            }
                        </ul>
                        <div className="slds-expression__buttons">
                            <button role="add-condition" className="slds-button slds-button_neutral"
                                onClick={() => { this.props.addCriteria(this.props.groupIndex); }}
                            >
                                <i className="cq-icon-add slds-m-right_x-small"></i> Add Condition</button>
                            <button role="add-group" className="slds-button slds-button_neutral"
                                onClick={() => { this.props.addGroupedFilter(this.props.groupIndex); }}>
                                <i className="cq-icon-add slds-m-right_x-small"></i> Add Group</button>
                            <button role="remove-group" className="slds-button slds-button_neutral"
                                onClick={() => { this.props.deleteCriteria(this.props.groupIndex); }}>
                                <i className="cq-2x cq-icon-delete slds-m-right_x-small"></i>Remove Group</button>
                        </div>
                    </fieldset>
                </li>
            </>
        );
    }
}

export default GroupComponent;
